export default __webpack_public_path__ + "media/flavours/glitch/images/elephant_ui_working.svg";